export default {
  setFlags: function setFlags(context, flags) {
    if (Object.keys(flags).includes('mlops_active')) {
      context.commit("setHasMlopsActive", flags.mlops_active);
    }
  }
};